/**
 * Subject icon catalogue — mirrors core/ui/subjects/SubjectIcons.kt.
 *
 * Maps the icon id string stored on `PlanningSchemeOverview.iconId`
 * (and shared SubjectIconCatalog) to a Lucide Vue component.
 *
 * Unknown ids fall back to BookOpen, matching Android.
 */
import {
  Atom,
  BookA,
  BookOpen,
  Brain,
  Briefcase,
  Calculator,
  ChefHat,
  Clapperboard,
  Cpu,
  Drama,
  Dumbbell,
  Film,
  FlaskConical,
  Gavel,
  Globe,
  Hammer,
  HeartHandshake,
  HeartPulse,
  Landmark,
  Languages,
  Leaf,
  Lightbulb,
  MessageCircle,
  Music,
  Palette,
  PersonStanding,
  Scale,
  ScrollText,
  Shirt,
  Sigma,
  Smile,
  Sparkles,
  TestTube,
  TrendingUp,
  Users,
  UsersRound,
} from 'lucide-vue-next'
import type { Component } from 'vue'

const SUBJECT_ICONS: Record<string, Component> = {
  Atom,
  BookA,
  BookOpen,
  Brain,
  Briefcase,
  Calculator,
  ChefHat,
  Clapperboard,
  Cpu,
  Drama,
  Dumbbell,
  Film,
  FlaskConical,
  Gavel,
  Globe,
  Hammer,
  HeartHandshake,
  HeartPulse,
  Landmark,
  Languages,
  Leaf,
  Lightbulb,
  MessageCircle,
  Music,
  Palette,
  PersonStanding,
  Scale,
  ScrollText,
  Shirt,
  Sigma,
  Smile,
  Sparkles,
  TestTube,
  TrendingUp,
  Users,
  UsersRound,
}

/** Resolve an icon id (e.g. "Calculator") to a Lucide component. */
export function subjectIcon(id: string | undefined | null): Component {
  if (!id) return BookOpen
  return SUBJECT_ICONS[id] ?? BookOpen
}

export const SubjectIconIds = Object.keys(SUBJECT_ICONS)
